import { render, staticRenderFns } from "./UnsoldModalTableItem.vue?vue&type=template&id=7b970b85"
import script from "./UnsoldModalTableItem.vue?vue&type=script&lang=js"
export * from "./UnsoldModalTableItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports